<template>
  <div class="flex flex-col w-3/4 md:w-11/12 mx-auto">
    <div class="flex flex-col mt-10" v-if="teacher.bio">
      <p v-html="teacher.bio" class="text-left font-sans-serif text-sm md:text-lg
      border-l-4 border-grey-academy-150 pl-2" />
    </div>
     <div class="flex flex-col mt-10">
       <div v-if="experiences.length>0">
          <h2 class="border-b-2 border-grey-academy-150 text-xl text-grey-academy-300
          font-bold mb-6 mt-6 uppercase pl-2">
            {{ $t('teacher.jobs') }}
          </h2>
          <work-experience-row
            v-for="experience in experiences"
            :key="experience.id"
            :workExperience="experience" />
        </div>
        <div class="mt-16" v-if="schools.length>0">
          <h2 class="border-b-2 border-grey-academy-150 text-xl text-grey-academy-300
          font-bold mb-6 uppercase pl-2">
            {{ $t('teacher.studies') }}
          </h2>
          <school-row
            v-for="school in schools"
            :key="school.id"
            :school="school" />
        </div>
        <div class="mt-16" v-if="instruments.length>0">
          <h2 class="border-b-2 border-grey-academy-150 text-xl text-grey-academy-300
          font-bold mb-6 pl-2 uppercase">
            {{ $t('teacher.instruments') }}
          </h2>
          <instrument-row
            v-for="instrument in instruments"
            :key="instrument.id"
            :instrument="instrument"/>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getTeacherBySlug, getTeacherExperiences, getTeacherInstruments } from '@/services/TeacherService';
import { getStudentSchools } from '@/services/StudentService';
import InstrumentRow from '../InstrumentRow.vue';
import WorkExperienceRow from '../WorkExperienceRow.vue';
import SchoolRow from '../SchoolRow.vue';

export default {
  components: { InstrumentRow, WorkExperienceRow, SchoolRow },
  data() {
    return {
      teacher: {},

      experiences: [],
      instruments: [],
      schools: [],
    };
  },

  created() {
    this.getTeacher();
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      isTeacher: 'auth/isTeacher',
    }),
  },

  methods: {
    getTeacher() {
      getTeacherBySlug(this.$route.params.slug).then(({ data }) => {
        this.teacher = data;
        this.getExperiences();
        this.getSchools();
        this.getInstruments();
      });
    },

    getExperiences() {
      getTeacherExperiences(this.teacher.id).then(({ data }) => {
        this.experiences = data;
      });
    },

    getSchools() {
      getStudentSchools(this.teacher.user.id).then(({ data }) => {
        this.schools = data;
      });
    },

    getInstruments() {
      getTeacherInstruments(this.teacher.id).then(({ data }) => {
        this.instruments = data;
      });
    },
  },

};
</script>
